import {useState} from "react";
import {account as strings} from "strings";

import AccountLink from "components/AccountLink";
import DeleteAccountModal from "components/DeleteAccountModal";
import Divider from "components/Divider";
import PageTitle from "components/PageTitle";

import styles from "./AccountPage.module.css";

export default function AccountPage() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  return (
    <>
      <PageTitle>{strings.account}</PageTitle>
      <Divider className={styles.divider} />
      <div className={styles.accountLinks}>
        <AccountLink
          className={styles.accountLink}
          label={strings.personal}
          to="/profile/account/personal-info"
        />
        <AccountLink
          className={styles.accountLink}
          label={strings.changePassword}
          to="/profile/account/change-password"
        />
        <AccountLink
          className={styles.accountLink}
          label={strings.deleteAccount}
          onChange={() => {
            setShowDeleteModal(true);
          }}
        />
        <DeleteAccountModal
          visible={showDeleteModal}
          onClickClose={() => {
            setShowDeleteModal(false);
          }}
        />
      </div>
    </>
  );
}
